<template>
  <content-box class="cancel-subscription--wrap" width="830px">
    <p class="title">{{ $t('common.cancelSubscription') }}</p>
    <div class="plan-info--wrap">
      <p class="row">
        <span class="term">{{ $t('common.planInUse') }}</span>
        <span class="value"><strong>{{ planData.planName }}</strong></span>
      </p>
      <p class="row terms">
        <span class="term">{{ $t('common.subscriptionTerms') }}</span>
        <span class="value">
          {{ planData.startDate | dashDate }} ~
          {{ planData.endDate | dashDate }}
        </span>
      </p>
      <p class="row">
        <span class="term">{{ $t('common.expiryDate') }}</span>
        <span class="value">{{ planExpireDate | dashDate }}</span>
      </p>
    </div>
    <div class="reason--wrap">
      <div class="reason-info">
        <p class="info" v-html="$t('common.whyLeavingUs.desc.cancelSubscription')"></p>
        <p v-if="reasonError === 'NO_REASON'" class="validation-text no-reason">{{ $t('common.validationErrorText.reason.requiredReason') }}</p>
      </div>
      <ul class="reasons clearfix">
        <li v-for="item in reasons" :key="item.reasonNum" class="clearfix">
          <div class="reason-box">
            <label :for="`cancel-reason-${item.reasonNum}`">
              <input type="radio" :id="`cancel-reason-${item.reasonNum}`" name="cancel-reason"
                     :value="item.reasonNum"
                     v-model="reasonNum"><i class="icon icon--radio-off"></i>
              <span class="reason-text">
                {{ $t(`common.whyLeavingUs.${item.textKey}`) }}
              </span>
            </label>

            <div style="position: relative;">
              <input v-if="item.reasonNum === 0" type="text" class="custom-reason"
                v-model.trim="customReason" :disabled="reasonNum !== 0"/>
              <p v-if="reasonError === 'NO_CUSTOM_REASON'" class="validation-text no-custom-reason">{{ $t('common.validationErrorText.reason.requiredExplain') }}</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="footer">
      <div class="button--wrap">
        <ui-button class="btn__cancel"
                   :primary2="true"
                   @click="$emit('onCloseLayer')">{{ $t('common.cancel') }}</ui-button>
        <ui-button class="btn__confirm"
                   :primary="true"
                   @click="onConfirm">{{ $t('common.confirm') }}</ui-button>
      </div>
    </div>
  </content-box>
</template>

<script>
import { addDays } from 'date-fns'
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'CancelSubscription',
  components: {
    ContentBox,
    UiButton
  },
  props: [
    'planData'
  ],
  data () {
    return {
      reasonNum: 1,
      customReason: '',
      reasonError: null,
      reasons: [
        {
          textKey: 'difficultUse',
          reasonNum: 1
        },
        {
          textKey: 'tooExpensive',
          reasonNum: 2
        },
        {
          textKey: 'notHaveFeature',
          reasonNum: 3
        },
        {
          textKey: 'barelyUse',
          reasonNum: 4
        },
        {
          textKey: 'otherService',
          reasonNum: 5
        },
        {
          textKey: 'otherReasons',
          reasonNum: 0
        }
      ]
    }
  },
  computed: {
    reason () {
      if (this.reasonNum === null) {
        return null
      } else if (this.reasonNum === 0) {
        return this.customReason
      } else {
        return this.reasons[this.reasonNum]
      }
    },
    planExpireDate () {
      return addDays(this.planData.endDate, 1)
    }
  },
  created () {
  },
  methods: {
    onConfirm () {
      this.reasonError = null

      if (this.reasonNum === null) {
        this.reasonError = 'NO_REASON'
        return
      }

      if (this.reasonNum === 0 && !this.customReason.length) {
        this.reasonError = 'NO_CUSTOM_REASON'
        return
      }

      const reason = {
        terminateReason: this.reasonNum
      }

      if (this.reasonNum === 0) {
        reason.reasonStr = this.customReason
      }
      this.$emit('onConfirm', reason)
      this.$emit('onCloseLayer')
    }
  }
}
</script>

<style lang="scss" scoped>
.cancel-subscription--wrap {
  padding: 30px 30px 25px;
  box-sizing: border-box;

  .title {
    font-size: 15px;
    font-weight: 600;
    color: #2f2f2f;
  }

  .plan-info--wrap {
    margin-top: 23px;
    padding: 16px 30px;
    box-sizing: border-box;
    border-radius: 5px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;

    .row {
      padding-top: 15px;
      padding-bottom: 15px;
      overflow: hidden;

      .term {
        font-size: 13px;
        font-weight: 600;
        color: #767676;
        float: left;
      }
      .value {
        float: right;
        font-size: 16px;
        color: #2f2f2f;

        strong {
          font-weight: 600;
          color: $brandColor;
        }
      }
    }

    .terms {
      border-top: 1px dashed #d7d7d7;
      border-bottom: 1px dashed #d7d7d7;
    }
  }

  .reason--wrap {
    padding-top: 40px;
    font-size: 14px;
    color: #767676;
    .reason-info {
      position: relative;
      margin-bottom: 36px;

      .no-reason {
        position: absolute;
        left: 0;
        top: 20px;
        color: $brandColor;
      }
    }
    .reasons {
      li {
        width: 50%;
        float: left;
        font-size: 13px;
        color: #2f2f2f;
        line-height: 1.4;
        input[type='radio'] {
          width: 0;
        }
      }
      .reason-box {
        display: block;
        padding-bottom: 20px;
        overflow: hidden;

        .icon {
          vertical-align: middle;
          margin-right: 8px;
        }
      }
      .custom-reason {
        box-sizing: border-box;
        display: block;
        margin-top: 14px;
        width: 100%;
        height: 38px;
        padding-left: 12px;
        padding-right: 12px;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        &[disabled] {
          background-color: #d7d7d7;
          opacity: 0.3;
        }
      }
      .no-custom-reason {
        position: absolute;
        top: 40px;
        left: 0;
        color: $brandColor;
      }
    }
  }

  .footer {
    padding-top: 25px;
    text-align: center;

    .button--wrap {
      .btn__confirm {
        margin-left: 5px;
      }
    }
  }
}
</style>
